export default "__VITE_ASSET__doB8bGSJ__ 584w";